export default __webpack_public_path__ + "locales/nl/Ldap.json?hash=28f9c78926dc9f0c97564765fdebde91";